import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
  ScrollView,
  Animated,
  ActivityIndicator,
  Modal,
} from "react-native";
import { styleSheet } from "app/utils/styleSheet";
import Text from "app/components/Text";
import valueHelpers from "app/utils/valueHelpers";
import textHelpers from "app/utils/textHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import store from "app/redux/store";

import MomentList from "app/components/chapter/MomentList";
import Icon from "app/components/Icon";
import AnimatedEllipsis from "app/components/AnimatedEllipsis";
import TextInput from "app/components/TextInput";
import RichText from "app/components/RichText";
import RichTextInput from "app/components/RichTextInput";
import ScratchPad from "app/components/ScratchPad";
import ProgressBar from "app/components/ProgressBar";
import JournalChatPanel from "app/components/JournalChatPanel";
import ValueNarrativeModal from "app/components/ValueNarrativeModal";

import Hoverable from "app/components/Hoverable";
import HoverableTooltip from "app/components/HoverableTooltip";
import {
  Ionicons,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class ValueNote extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    value: PropTypes.object.isRequired,
    // onPress: PropTypes.func,
  };

  static defaultProps = {
    scale: 1.0,
    scale: 0.5,
    iconScale: 1.0,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: true,
      color: valueHelpers.colorAsHex(props.value.color, context.colorScheme),
      // dueIn: frequencyHelpers.getDueIn(props.value),
      expandedBody: false,
      expandedWidth: false,
      isHovered: false,
      isLoitering: false,
      title: props.value.title,
      body: props.value.text,
      editingBody: false,
      value: props.value,
      showActions: false,
      knownUpdatedAt: props.value.updated_at,
      showJournalChat: false,
      showValueNarrative: false,
    };
  }

  componentDidMount = async () => {
    let { value } = this.props;
    this.subscribe();
    valueActions.get(value.id);
    let res = await valueActions.get(
      value.id,
      // scopeToChapter && !rootChapter?.is_value && rootChapter?.id
    );
    console.log(res);
    this.setState({ loading: false });
  };

  componentWillUnmount() {
    this.unsubscribeRedux && this.unsubscribeRedux();
  }

  subscribe = async () => {
    this.unsubscribeRedux = store.subscribe(() => {
      let { values, app } = store.getState();
      // let { loading } = app;
      let value = values.find((v) => v.id == this.props.value?.id);
      if (textHelpers.compareObjects(value, this.state.value)) return;
      this.setState({ value });
    });
  };

  focus = async () => {
    if (this.state.expandedBody) {
      this.titleRef?.focus();
    } else {
      await this.setState({ expandedBody: true });
      await new Promise((r) => setTimeout(r, 100));
      this.titleRef?.focus();
    }
  };

  render() {
    let { value, isHovered, expandedBody, expandedWidth, color, isLoitering, showJournalChat, showValueNarrative, title, body } =
      this.state;
    // let darkenedColor = valueHelpers.iconColor(value, color).color;

    let completionOpacity = 1;
    if (
      (!!value.completed_at || !!value.archived_at) &&
      !isHovered &&
      !expandedWidth &&
      !expandedBody
    )
      completionOpacity = 0.4;

    let fullCompletionOpacity = completionOpacity;
    completionOpacity = 1;

    let mini = !!value.completed_at && !expandedBody && !isHovered;

    let borderRadius = value.is_note ? 0 : this.context.sizes.borderRadius;

    return (
      <Hoverable
        onHoverIn={() => {
          // console.log("hover in");
          this.setState({ isHovered: true });
          this.hoveringTimeout = setTimeout(
            () => this.setState({ isLoitering: true }),
            800,
          );
        }}
        onHoverOut={() => {
          if (!!this.hoveringTimeout) clearTimeout(this.hoveringTimeout);
          this.setState({ isHovered: false, isLoitering: false });
        }}
      >
        <View
          style={[
            this.styles().wrapper,
            !!this.props.width && { width: this.props.width },
            { opacity: fullCompletionOpacity },
            expandedWidth && this.styles().expanedWrapper,
          ]}
        >
          <View
            style={[
              {
                ...StyleSheet.absoluteFillObject,
                borderRadius,
                backgroundColor: this.context.colors.fill,
                opacity: completionOpacity,
              },
            ]}
          />

          <View
            style={{
              ...StyleSheet.absoluteFillObject,
              borderRadius,
              opacity: completionOpacity,
            }}
          >
            <View
              style={{
                ...StyleSheet.absoluteFillObject,
                borderRadius,
                backgroundColor: color,
                opacity: value.is_note ? 0.05 : 0.2,
              }}
            />
          </View>

          <View
            style={{
              zIndex: 9,
              opacity: completionOpacity,
              ...this.styles().titleRowWrapper,
            }}
          >
            {this.renderTitle()}
            {mini && this.renderParents()}
          </View>

          {(!value.completed_at || expandedBody) && (
            <View style={{ zIndex: 8 }}>{this.renderBody()}</View>
          )}

          {!mini && <View>{this.renderFooter(completionOpacity)}</View>}

          {this.renderProgressBar(mini)}
        </View>
        <Modal
          visible={!!showJournalChat}
          transparent
          animationType="fade"
          onRequestClose={() => this.setState({ showJournalChat: false })}
        >
          <JournalChatPanel
            currentText={body}
            currentTitle={title}
            currentValueId={value.id}
            onClose={() => this.setState({ showJournalChat: false })}
          />
        </Modal>
        <Modal
          visible={!!showValueNarrative}
          transparent
          animationType="fade"
          onRequestClose={() => this.setState({ showValueNarrative: false })}
        >
          <ValueNarrativeModal
            value={value}
            onClose={() => this.setState({ showValueNarrative: false })}
          />
        </Modal>
      </Hoverable>
    );
  }

  renderTitle = () => {
    let { value, loading, expandedBody, expandedWidth, isHovered, title } =
      this.state;

    let buttons = null;
    if (expandedBody || isHovered) {
      buttons = (
        <View style={{ flexDirection: "row" }}>
          <View style={{ flexDirection: "row", zIndex: 2 }}>
            <HoverableTooltip
              delay
              text={expandedWidth ? "Collapse" : "Expand"}
            >
              <MaterialCommunityIcons
                name={expandedWidth ? "arrow-collapse" : "arrow-expand"}
                color={this.context.colors.foreground}
                style={[
                  styleSheet.bullet,
                  { borderColor: this.context.colors.foreground },
                ]}
                onPress={(e) => {
                  this.setState({
                    expandedWidth: !expandedWidth,
                    expandedBody: !expandedWidth ? true : expandedBody,
                  });
                }}
              />
            </HoverableTooltip>
            <HoverableTooltip delay text="Go to item">
              <Entypo
                name="chevron-right"
                color={this.context.colors.foreground}
                style={[
                  styleSheet.bullet,
                  { borderColor: this.context.colors.foreground },
                ]}
                onMouseDown={(e) => {
                  RootNavigation.push("Value", { id: value.id }, e);
                }}
                onPress={(e) => {
                  if (ENV.WEB) return;
                  RootNavigation.push("Value", { id: value.id });
                }}
              />
            </HoverableTooltip>
          </View>
          {expandedBody && (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                // marginTop: this.context.sizes.small,
              }}
            >
              <HoverableTooltip delay text="Close">
                <Ionicons
                  name={"close"}
                  color={this.context.colors.foreground}
                  style={[
                    styleSheet.bullet,
                    { borderColor: this.context.colors.foreground },
                  ]}
                  onPress={(e) => {
                    this.setState({
                      expandedWidth: false,
                      expandedBody: false,
                    });
                  }}
                />
              </HoverableTooltip>
            </View>
          )}
        </View>
      );
    }

    if (!expandedBody) {
      return (
        <View style={this.styles().titleRow}>
          <Text
            bold
            numberOfLines={1}
            // strike={!!value.completed_at}
            onPress={this.expandBody}
          >
            {/*value.is_note && "note: "*/}
            {valueHelpers.filterRichText(value.title || value.text, value)}
          </Text>
          {buttons}
        </View>
      );
    }
    return (
      <View style={this.styles().titleRow}>
        <RichTextInput
          ref={(r) => (this.titleRef = r)}
          lineIndex={0}
          value={value}
          references={value?.references}
          onChangeText={(title) => {
            this.setState({ title });
            this.handleChangeTitle();
          }}
          onStopEditing={() => this.handleChangeTitle(0)}
          onEscape={() => this.handleChangeTitle(0)}
          onAltLeft={this.props.handleFocusPrevious}
          onAltRight={this.props.handleFocusNext}
          focusNext={this.scratchPadRef?.focus}
          bold
        >
          {title}
        </RichTextInput>
        {/*<TextInput
          bold
          value={title}
          // strike={!!value.completed_at}
          multiline
          autoHeight
          placeholder={"Untitled"}
          placeholderTextColor={this.context.colors.foreground}
          onChangeText={(title) => {
            this.setState({ title });
            this.handleChangeTitle();
          }}
          onBlur={() => this.handleChangeTitle(0)}
          style={{ flex: 1 }}
        />*/}
        {buttons}
      </View>
    );
  };

  renderBody = () => {
    let {
      value,
      loading,
      expandedBody,
      expandedWidth,
      editingBody,
      body,
      showActions,
      color,
    } = this.state;
    if (loading) return <AnimatedEllipsis />;

    let children = valueHelpers.getChildren({ value, includeNotes: true });
    let tasks = children.filter((c) => !c.is_note);
    let completedTasks = tasks.filter((c) => !!c.completed_at);

    if (!expandedBody) {
      let body = "";
      if (!!children?.length) {
        if (tasks?.length) {
          body += `[${completedTasks.length}/${tasks.length}] `;
        }
        children.forEach((c) => (body += `• ${c.title || c.text} `));
        // } else if (!value.is_note) {
        //   return null;
      } else if (!!value.title && value.title != value.text) {
        body = valueHelpers.filterRichText(value.text, value);
      }
      return (
        <TouchableOpacity onPress={this.expandBody}>
          <Text
            numberOfLines={2}
            // style={{ wordWrap: "break-word" }}
            style={{ cursor: "text" }}
          >
            {body}
          </Text>
        </TouchableOpacity>
      );
    } else {
      let scratchPad = (
        <ScratchPad
          inline
          value={value}
          ref={(r) => (this.scratchPadRef = r)}
          focusPrevious={this.titleRef?.focus}
          focusNext={this.momentListRef?.handleFocusFirstMoment}
          showActions={showActions}
          // onAltLeft={this.props.handleFocusPrevious}
          // onAltRight={this.props.handleFocusNext}
        />
      );
      if (!!children?.length) {
        return (
          <View>
            {expandedWidth ? (
              scratchPad
            ) : (
              <ScrollView style={{ maxHeight: 200 }}>{scratchPad}</ScrollView>
            )}
            <View
              style={{
                borderLeftWidth: 1,
                borderColor: color,
                marginTop: this.context.sizes.base,
              }}
            >
              <MomentList
                showBody
                ref={(r) => (this.momentListRef = r)}
                value={value}
                parentIsValue
                parentId={value.id}
                textColor={this.context.colors.foreground}
                moments={children.map((c) => ({ value: c }))}
                focusParentMoment={() => this.scratchPadRef?.focus(9999)}
              />
            </View>
          </View>
        );
      } else {
        return scratchPad;
      }
    }
  };

  renderFooter = (completionOpacity) => {
    let { value, expandedBody, color, isHovered, showActions } = this.state;
    return (
      <View
        style={[
          this.styles().footerWrapper,
          expandedBody && this.styles().expandedFooterWrapper,
        ]}
      >
        {expandedBody && (
          <View style={{ flexDirection: 'row', alignItems: 'center', marginRight: this.context.sizes.base }}>
            <Feather
              name={showActions ? "x" : "more-horizontal"}
              style={{ marginRight: this.context.sizes.base }}
              color={this.context.colors.foreground}
              size={this.context.sizes.default}
              onPress={() => this.setState({ showActions: !showActions })}
            />
            <MaterialCommunityIcons
              name="creation"
              color={this.context.colors.foreground}
              size={this.context.sizes.default}
              onPress={() => this.setState({ showJournalChat: true })}
            />
            <Feather
              name="book-open"
              style={{ marginLeft: this.context.sizes.base }}
              color={this.context.colors.foreground}
              size={this.context.sizes.default}
              onPress={() => this.setState({ showValueNarrative: true })}
            />
          </View>
        )}
        <TouchableWithoutFeedback onPress={this.collapseBody}>
          <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center' }}>
            <HoverableTooltip
              delay
              text={`Created: ${textHelpers.formatDate(value.created_at, false)}`}
              rightAligned={false}
            >
              <Text small style={{ opacity: completionOpacity }}>
                {textHelpers.formatDate(value.created_at, false, false, false)}
              </Text>
            </HoverableTooltip>
            <Hoverable>
              {(isHovered) => (
                <View
                  style={{
                    cursor: "grab",
                    flex: 1,
                    opacity: 0.1,
                    marginBottom: -this.context.sizes.base,
                  }}
                ></View>
              )}
            </Hoverable>
            {this.renderParents()}
          </View>
        </TouchableWithoutFeedback>
      </View>
    );
  };

  renderParents = () => {
    let { value } = this.state;
    let parents = valueHelpers.getParents({ value });
    return (
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        {/*!!value.child_ids?.length && (
        <Text style={{ opacity: 0.5 }}>0/{value.child_ids.length}</Text>
      )*/}

        {parents.map((parent, i) => (
          <HoverableTooltip delay text={parent.title || parent.text} key={i}>
            {(isHovered) => (
              <Icon
                onPress={() => RootNavigation.push("Value", { id: parent.id })}
                color={valueHelpers.colorAsHex(
                  parent?.color,
                  this.context.colorScheme,
                )}
                size={this.context.sizes.default}
                name={valueHelpers.getIcon(parent)}
                style={[
                  { marginLeft: this.context.sizes.small },
                  isHovered && { transform: [{ scale: 1.5 }] },
                ]}
              />
            )}
          </HoverableTooltip>
        ))}
      </View>
    );
  };

  renderProgressBar = (mini = false) => {
    let { value, expandedBody, color, isHovered } = this.state;

    if (value.progress_at?.length <= 1 && mini) return null;

    if (value.progress_at?.length > 1) return this.renderNotchedProgressBar();

    if (!!value.percent) {
      let right = 100 - value.percent * 100;
      return (
        <View
          style={[
            this.styles().progressWrapper,
            value.is_note && this.styles().noteProgressWrapper,
          ]}
          pointerEvents="none"
        >
          <ProgressBar value={value} color={color} />
        </View>
      );
      return (
        <View
          style={[
            this.styles().progressWrapper,
            value.is_note && this.styles().noteProgressWrapper,
          ]}
          pointerEvents="none"
        >
          {/*<View
            style={[
              this.styles().progressBar,
              {
                backgroundColor: this.context.colors.empty,
                // opacity: 0.5,
                right: 0,
              },
            ]}
          />
          <View
            style={[
              this.styles().progressBar,
              {
                backgroundColor: color,
                opacity: 0.2,
                right: 0,
              },
            ]}
          />*/}
          <View
            style={[
              this.styles().progressBar,
              {
                backgroundColor: color,
                right: `${right}%`,
              },
            ]}
          />
        </View>
      );
    }
  };

  renderNotchedProgressBar = (mini = false) => {
    let { value, color } = this.state;
    let cycle = Math.max(value.cycle || 7, value.progress_at.length);
    let progressions = [...value.progress_at];
    let stop = false;
    while (!stop && progressions.length < cycle) {
      progressions.push(null);
    }
    return (
      <View
        style={[
          this.styles().progressWrapper,
          value.is_note && this.styles().noteProgressWrapper,
        ]}
        pointerEvents="none"
      >
        <ProgressBar value={value} color={color} />
      </View>
    );
    return (
      <View
        style={[
          this.styles().progressWrapper,
          value.is_note && this.styles().noteProgressWrapper,
        ]}
        pointerEvents="none"
      >
        {progressions.map((p, i) => {
          return (
            <View
              key={i}
              style={[
                {
                  flex: 1,
                  height: 4,
                  backgroundColor: !!p ? color : undefined,
                  marginRight: i == cycle - 1 ? 0 : 2,
                },
              ]}
            />
          );
        })}
      </View>
    );
  };

  expandBody = () => {
    if (this.state.expandedBody) return;
    this.setState({ expandedBody: true });
  };

  collapseBody = () => {
    if (!this.state.expandedBody) return;
    this.setState({ expandedBody: false });
    this.handleChangeTitle(0);
    // this.handleChangeBody(0);
  };

  handleChangeTitle = async (delay = 1000) => {
    if (this.updateTitleTimeout) clearTimeout(this.updateTitleTimeout);
    this.updateTitleTimeout = setTimeout(this.updateTitle, delay);
  };

  handleChangeBody = async (delay = 1000) => {
    if (this.updateBodyTimeout) clearTimeout(this.updateBodyTimeout);
    this.updateBodyTimeout = setTimeout(this.updateBody, delay);
  };

  updateTitle = async () => {
    let { value, title, knownUpdatedAt } = this.state;
    const sendKnownUpdatedAt = knownUpdatedAt;
    this.setState({ knownUpdatedAt: new Date().toISOString() });
    let res = await valueActions.update(value.id, { title }, null, sendKnownUpdatedAt);
    if (res?.conflict) {
      console.warn("ValueNote: remote conflict detected, preserving local title");
      this.setState({ knownUpdatedAt: res.value.updated_at });
    } else if (res?.updated_at) {
      this.setState({ knownUpdatedAt: res.updated_at });
    }
  };

  updateBody = async () => {
    let { value, body, knownUpdatedAt } = this.state;
    const sendKnownUpdatedAt = knownUpdatedAt;
    this.setState({ knownUpdatedAt: new Date().toISOString() });
    let res = await valueActions.update(value.id, { text: body }, null, sendKnownUpdatedAt);
    if (res?.conflict) {
      console.warn("ValueNote: remote conflict detected, preserving local body");
      this.setState({ knownUpdatedAt: res.value.updated_at });
    } else if (res?.updated_at) {
      this.setState({ knownUpdatedAt: res.updated_at });
    }
  };

  styles = () => {
    return {
      wrapper: {
        // backgroundColor: this.context.colors.fill,
        borderRadius: this.context.sizes.borderRadius,
        padding: this.context.sizes.base,
        // overflow: "hidden",
        width: 300,
      },
      expanedWrapper: {
        width: 700,
        // width: this.context.sizes.WIDTH - this.context.sizes.base * 3,
        padding: this.context.sizes.giant,
      },
      titleRowWrapper: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      },
      titleRow: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "space-between",
      },
      footerWrapper: {
        flexDirection: "row",
        // justifyContent: "space-between",
        paddingTop: this.context.sizes.small,
      },
      expandedFooterWrapper: {
        marginTop: this.context.sizes.base,
      },
      dot: {
        width: this.context.sizes.base,
        height: this.context.sizes.base,
        borderRadius: 99,
        marginLeft: this.context.sizes.small,
      },
      progressWrapper: {
        overflow: "hidden",
        height: this.context.sizes.borderRadius,
        borderBottomRightRadius: this.context.sizes.borderRadius,
        borderBottomLeftRadius: this.context.sizes.borderRadius,
        position: "absolute",
        // borderWidth: 1,
        bottom: 0,
        left: 0,
        right: 0,
        // height: 3,
        flexDirection: "row",
        alignItems: "flex-end",
      },
      noteProgressWrapper: {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
      },
      progressBar: {
        ...StyleSheet.absoluteFillObject,
        height: 4,
        top: undefined,
      },
    };
  };
}
